<template>
  <v-container
    pa-0
    fluid
  >
    <v-layout>
      <v-flex xs12>
        <label for="address">Company Address</label>
        <v-alert
          type="error"
          :value="errors.any('address')"
        ></v-alert>
        <form autocomplete="off">
          <v-autocomplete
            id="address"
            :items="results"
            :allow-overflow="true"
            label="Start typing to search Company Address"
            :search-input.sync="search"
            v-model="streetAddress"
            item-text="formatted_address"
            item-value="formatted_address"
            @change="completeAddress"
            persistent-hint
            name="address"
            ref="addressInput"
            attach="companyContainer"
            v-validate="'required'"
            :error-messages="errors.collect('address')"
            class="entry"
          ></v-autocomplete>
        </form>
      </v-flex>
    </v-layout>

    <v-layout wrap>
      <v-flex
        xs12
        md6
      >
        <label for="abn">ABN</label>
        <v-text-field
          id="abn"
          name="abn"
          type="number"
          data-vv-as="ABN"
          v-model="company.abn"
          :loading="loading"
          lazy-validation="true"
          v-validate="'required|digits:11'"
          :error-messages="errors.collect('abn')"
          autocomplete="disabled"
          @change="updateABN"
          class="entry"
        ></v-text-field>
      </v-flex>
      <v-flex
        xs12
        md6
      >
        <label for="companyName">Company Name</label>
        <v-text-field
          id="companyName"
          name="name"
          v-model="company.name"
          data-vv-as="Company Name"
          lazy-valiation="true"
          v-validate="'required|max:80'"
          :error-messages="errors.collect('name')"
          :readonly="summary"
          class="entry"
        ></v-text-field>
      </v-flex>

    </v-layout>

    <v-btn
      :disabled="errors.any() || !company.address.suburb"
      color="primary"
      @click="submit(false)"
    >Continue</v-btn>

    <v-btn flat>Cancel</v-btn>
  </v-container>
</template>

<script>
import { mapActions, } from "vuex";

export default {
  name: "CompanyDetail",
  data () {
    return {
      loading: false,
      hasErrors: false,
      search: null,
      streetAddress: null,
      results: []
    };
  },
  props: {
    company: { type: Object, required: true },
    industryTypes: { type: Array, required: true },
    industrySubTypes: { type: Array, required: true },
    summary: { type: Boolean, required: true }
  },
  computed: {
    isGoogleChrome () {
      return (
        /Chrome/.test(navigator.userAgent) &&
        /Google Inc/.test(navigator.vendor)
      );
    }
  },
  methods: {
    ...mapActions("orders/address", ['searchAddress']),
    updateABN (e) {
      this.$emit("abnChanged", e);
    },
    completeAddress (e) {
      let vm = this;
      if (e) {
        let match = vm.results.filter(x => x.formatted_address === e);
        if (match.length > 0) {
          let splitStreetAddress = e.split(" ");
          vm.company.address.suburb = match[0].suburb;
          vm.company.address.state =
            splitStreetAddress[splitStreetAddress.length - 2];
          vm.company.address.postcode = match[0].postcode;
          vm.company.address.line1 = e.substring(0, e.indexOf(","));
        }
      }
    },
    getAddressData: function (addressData) {
      this.updateAddress(addressData);
    },
    submit (validate) {
      return new Promise((resolve, reject) => {
        let vm = this;

        vm.$validator.validateAll().then(result => {
          if (result) {
            vm.hasErrors = false;
            if (vm.company.address.line1.length > 0 && !validate)
              vm.$emit("updated", vm.company);
            else {
              vm.errors.items.push({
                field: "address",
                msg: "The address must be entered via the search box",
                rule: "required"
              });
            }
            resolve(!vm.hasErrors);
          } else {
            vm.hasErrors = true;
            resolve(!vm.hasErrors);
          }
        });
      });
    }  },
  watch: {
    search (val) {
      let vm = this;
      if (val !== null) {
        if (val.length > 5)
          vm.searchAddress(val).then(data => {
            this.results = data;
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>